import { SET_ERROR, EDIT_ENTRY_OR_DEPARTURE, CLEAN_FILTERS, DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT, SET_CHANGE_FETCHING, SET_RESOURCE_DETAIL, GET_ENTRIES_AND_DEPARTURES, SET_PAGE, SET_FILTERS, SET_TABLE_HEADERS, DOWNLOADING } from "./types";

const EntryAndDepartureReportReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_ENTRIES_AND_DEPARTURES:
            return {
                ...state,
                entriesAndDeparturesPaginated: payload.entriesAndDepartures,
                totalPages: payload.totalPages,
                isFetching: false,
                error: payload.error
            }
        case SET_FILTERS:
            return {
                ...state,
                filters: payload,
                isFetching: true,
            }
        case SET_TABLE_HEADERS:
            return {
                ...state,
                tableHeaders: payload,
            }
        case SET_PAGE:
            return {
                ...state,
                page: payload,
            }
        case SET_RESOURCE_DETAIL:
            return {
                ...state,
                resourceDetail: payload.resourceDetail,
                error: payload.error
            }
        case SET_CHANGE_FETCHING:
            return {
                ...state,
                isFetching: payload,
            }
        case SET_ERROR:
            return {
                ...state,
                error: payload,
            }
        case DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT:
            return {
                ...state,
                error: payload,
            }
        case CLEAN_FILTERS:
            return {
                ...state,
                filters: payload,
            }
        case EDIT_ENTRY_OR_DEPARTURE:
            return {
                ...state,
                error: payload,
            }
        case DOWNLOADING:
            return {
                ...state,
                isDownloadingReport: payload,
            }
        default:
            return state
    }
}

export default EntryAndDepartureReportReducer